// @flow
import { noop, without, omit } from 'lodash';

import {
  API_CALL_FAILURE,
  API_CALL_REQUEST,
  API_CALL_SUCCESS,
  CLEAR_FRIEND_SEARCH_RESULTS
} from '../constants/actionTypes';
import { SEARCH_USER, USER_SIGN_OUT } from '../constants/apiTypes';
import decodeUser from '../normalizers/decodeUser';
import createReducer from '../utils/createReducer';
import switchFunc from '../utils/switchFunc';

const initialState: FriendSearchState = {
  users: {},
  errors: null,
  isSearchingUsers: new Set()
};

function onSearchUsers(
  state: FriendSearchState,
  action: { users: Array<Object>, searchId: number | string }
) {
  return {
    isSearchingUsers: new Set(without(state.isSearchingUsers, action.searchId)),
    users: {
      ...state.users,
      [action.searchId]: action.users.map(decodeUser)
    }
  };
}

const apiRequestReducer = switchFunc(
  {
    [SEARCH_USER]: (state, action: { searchId: number | string }) => ({
      errors: null,
      isSearchingUsers: new Set([...state.isSearchingUsers, action.searchId])
    })
  },
  () => noop
);

const apiSuccessReducer = switchFunc(
  {
    [SEARCH_USER]: onSearchUsers,
    [USER_SIGN_OUT]: () => initialState
  },
  () => noop
);

const apiFailureReducer = switchFunc(
  {
    [SEARCH_USER]: (state: FriendSearchState, action: { searchId: number | string }) => ({
      errors: action.errors,
      isSearchingUsers: new Set(without(state.isSearchingUsers, action.searchId))
    })
  },
  () => noop
);

export default createReducer(initialState, {
  [API_CALL_REQUEST]: (state, action) => ({
    ...apiRequestReducer(action.api)(state, action)
  }),
  [API_CALL_SUCCESS]: (state, action) => ({
    ...apiSuccessReducer(action.api)(state, action)
  }),
  [API_CALL_FAILURE]: (state, action) => ({
    ...apiFailureReducer(action.api)(state, action)
  }),
  [CLEAR_FRIEND_SEARCH_RESULTS]: (state, action) => ({
    users: {
      ...omit(state.users, [action.searchId])
    }
  })
});
